/* Pijlknoppen over de productfoto, 2026-09-03.

   Op de desktopversie is de grote foto géén schuifgalerij: alleen de actieve foto
   staat in de pagina, de rest staat op display:none. Wisselen gebeurt via de
   miniaturen eronder. De pijlknoppen die het thema zelf meebrengt staan op desktop
   uit en zouden hier ook niets doen — die schuiven een lijst die niet schuift.

   Daarom klikken deze knoppen de vorige of volgende miniatuur aan. Dat is precies
   wat een bezoeker anders zelf zou doen, dus alles wat het thema daaraan vastheeft
   (de actieve staat, de voorleesbare labels, het meeschuiven van de strook
   miniaturen) blijft werken.

   De galerij loopt rond: voorbij de laatste foto kom je weer bij de eerste. */

(function () {
  var galerij = document.querySelector('#MainContent media-gallery');
  if (!galerij) return;

  var viewer = galerij.querySelector('[id^="GalleryViewer-"]');
  var miniaturen = Array.prototype.slice.call(
    galerij.querySelectorAll('.thumbnail-list__item')
  );

  /* Eén foto: dan valt er niets te bladeren. */
  if (!viewer || miniaturen.length < 2) return;

  function huidige() {
    for (var i = 0; i < miniaturen.length; i++) {
      var knop = miniaturen[i].querySelector('.thumbnail');
      if (knop && knop.getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  function blader(richting) {
    var i = huidige() + richting;
    if (i < 0) i = miniaturen.length - 1;
    if (i >= miniaturen.length) i = 0;

    var knop = miniaturen[i].querySelector('.thumbnail');
    if (knop) knop.click();
  }

  function maakKnop(kant, richting, label) {
    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'gp-pijl gp-pijl--' + kant;
    knop.setAttribute('aria-label', label);
    knop.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      blader(richting);
    });
    return knop;
  }

  viewer.classList.add('gp-viewer');
  viewer.appendChild(maakKnop('vorige', -1, 'Vorige afbeelding'));
  viewer.appendChild(maakKnop('volgende', 1, 'Volgende afbeelding'));
})();
